// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	color: white;
	margin: 0;
	padding: 0px;
	box-sizing: border-box;
	font-family: montserrat, sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6,
a {
	color: white;
}

textarea {
	border: 1px solid transparent;
	padding-left: 5px;
	background-color: #464f5b;
	min-height: 80px !important;
}
textarea:hover {
	border-color: #0595db;
}
textarea:focus {
	border-color: #0595db;
	outline: 0;
	background-color: #464f5b;
	box-shadow: none;
}
textarea.ant-input {
	color: black;
	background-color: #e8eaed;
}
textarea.ant-input:focus {
	color: white;
	background-color: #464f5b;
}

label {
	font-weight: 200;
	font-size: 16px;
}

input {
	height: 35px;
	border: 1px solid transparent !important;
	padding-left: 5px;
	background-color: #464f5b !important;
	border-right-color: transparent !important;
}
input:hover {
	border-color: #0372aa !important;
}
input:focus {
	border-color: #0372aa !important;
	outline: 0;
	background-color: #464f5b;
	box-shadow: none;
}
input:-webkit-autofill {
	box-shadow: 0 0 0 1000px #464f5b inset;
	border: 1px solid transparent;
	-webkit-background-clip: content-box;
	-webkit-text-fill-color: white;
	caret-color: white;
}
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
	border-color: #0372aa !important;
}
input::-ms-reveal,
input::-ms-clear {
	display: none;
}
input[disabled] {
	background: rgb(57, 64, 73) !important;
	color: rgb(199, 199, 199) !important;
	cursor: not-allowed !important;
	border-color: transparent !important;
	-webkit-text-fill-color: rgb(199, 199, 199);
	background-clip: padding-box !important;
}
input[disabled]:hover {
	border-color: #0372aa !important;
}

select {
	background-color: #464f5b;
	height: 35px;
	border: 1px solid transparent;
	padding-left: 5px;
}
select:hover {
	border-color: #0372aa;
}
select:focus {
	border-color: #0595db;
	outline: 0;
	background-color: #464f5b;
	box-shadow: none;
}
select[disabled] {
	background: rgb(57, 64, 73) !important;
	color: rgb(199, 199, 199);
	cursor: not-allowed !important;
}
option {
	border: none;
}
.App {
	/* height: 100vh; */
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	background-color: rgb(57, 64, 73);
	width: inherit;
	/* scrollbar-color: #6969dd #e0e0e0; */
	/* scrollbar-width: thin; */
}

.AppMain {
	display: flex;
	width: 100%;
	/* height: inherit; */
}

.rootContainer {
	height: 100vh;
	display: flex;
	flex-direction: column;
}

button {
	cursor: pointer;
	border: 0;
	font-size: 16px;
}

.rmsc {
	--rmsc-main: #3a09e7d0;
	--rmsc-hover: rgb(119, 123, 128);
	--rmsc-selected: rgb(103, 110, 121);
	--rmsc-border: #333;
	--rmsc-gray: rgb(255, 255, 255);
	--rmsc-bg: rgb(70, 79, 91) !important;
	--rmsc-p: 5px;
	--rmsc-radius: 0px;
	--rmsc-h: 36px;
	margin-top: 3px;
}
.dropdown-content span {
	color: white;
	z-index: 999;
}
.dropdown-content input {
	color: white;
	max-width: 10%;
}

.dropdown-heading-value {
	overflow: visible !important;
}

.dropdown-heading-value span {
	color: white;
	font-size: 12px;
}

.LineFormNewStructure .form-control {
	width: 100% !important;
	margin-top: 5px;
}
::-webkit-scrollbar {
	width: 10px;
	background-color: transparent;
	margin-left: 20px;
	background-color: #202c38;
}
::-webkit-scrollbar-track {
	/* background: transparent !important; */
	background: #202c38;
}
::-webkit-scrollbar-thumb {
	background: #464f5b;
}
::-webkit-scrollbar-thumb:hover {
	background: #555;
}

a:focus {
	text-decoration: none;
	color: white;
}
.tooltip {
	width: 250px;
}
#menu * {
	list-style: none;
	color: black;
	background-color: transparent;
}
#menu li {
	line-height: 130%;
	font-size: 24px;
}
#menu li a {
	color: #222;
	text-decoration: none;
	font-size: 16px;
	line-height: 0px;
	margin-bottom: 20px;
}
#menu li a:before {
	content: "\\025b8";
	color: #ddd;
	margin-right: 6px;
	display: none;
}
#menu input[name="list"] {
	position: absolute;
	left: -1000em;
}
#menu label:before {
	content: "\\025b8";
	margin-right: 4px;
	color: black;
} /* viñetas */
#menu input:checked ~ label:before {
	content: "\\025be";
}
#menu .interior {
	display: none;
}
#menu input:checked ~ ul {
	display: block;
}
#menu div {
	color: #222;
	text-decoration: none;
	font-size: 16px;
	line-height: 30px;
	margin-bottom: 10px;
}

.select-item {
	background-color: #464f5b !important;
}

.item-renderer {
	align-items: center !important;
}

.dropdown-container {
	border-color: #464f5b !important;
}

@media only screen and (max-width: 360px) {
	.dropdown-heading-value span {
		font-size: 9px;
	}
}

/* ================ MAPBOX - MAP ================ */
/* .mapboxgl-canvas {
	height: unset !important;
	max-width: 100%;
	min-height: 650px;
	position: relative !important;
}
@media only screen and (max-width: 540px) {
	.mapboxgl-canvas {
		min-height: 340px;
		max-height: 340px;
	}
}
.mapboxgl-map {
	height: unset !important;
} */
#mapContainer {
	min-height: 340px;
}
.mapboxgl-map {
	min-height: 340px;
}
.mapboxgl-ctrl-bottom-right {
	display: none;
}
a.mapboxgl-ctrl-logo {
	display: none;
}
.mapboxgl-ctrl-geocoder--powered-by {
	display: none !important;
}
/* ========= MAPBOX GEOCODER INPUT ========= */
.mapboxgl-ctrl-geocoder .suggestions {
	background-color: #37404a;
}
.suggestions > .active > a {
	background-color: #5a6167 !important;
}
.suggestions > li > a:hover {
	background-color: #5a6167 !important;
}
.mapboxgl-ctrl-geocoder.mapboxgl-ctrl > input {
	color: white;
	background-color: rgb(70, 79, 91);
}
.mapboxgl-ctrl-geocoder--input {
	height: 35px;
	font-size: 14px !important;
	padding: 6px 40px !important;
	font-family: montserrat, sans-serif !important;
}
.mapboxgl-ctrl-geocoder--input:focus {
	outline: none;
}
.mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--pin-right > * {
	background-color: rgb(70, 79, 91);
}
.mapboxgl-ctrl button:not(:disabled):hover {
	background-color: rgb(70, 79, 91);
}
.mapboxgl-ctrl-geocoder--icon {
	fill: white;
}
.mapboxgl-ctrl-geocoder.mapboxgl-ctrl {
	width: 100%;
	max-width: none;
	max-width: initial;
}
.mapboxgl-ctrl-geocoder--icon-search {
	left: 7px !important;
	width: 20px !important;
	height: 20px !important;
	top: 8px !important;
}
/* ========= MAPBOX POPUP LAYOUT ========= */
.mapboxgl-popup-content {
	background-color: rgba(2, 3, 3, 0.8) !important;
	color: #fff;
	box-shadow: 0px 0px 5px 5px rgba(58, 83, 104, 0.5), inset 0px 0px 25px 5px rgba(58, 83, 104, 0.5) !important;
	font-family: "Open Sans", sans-serif;
	padding: 20px !important;
}
.mapboxgl-popup-tip {
	color: rgba(58, 83, 104, 0.8);
}
.mapboxgl-popup-close-button {
	top: 5px !important;
	right: 10px !important;
}
.mapboxgl-popup {
	max-width: 300px !important;
	/* writing-mode: horizontal-tb; */
}
/* ========= NOTIFICATION - ANTD ========= */
.ant-notification-notice {
	background-color: #515d66;
}
.ant-notification-notice-message {
	color: white;
	font-weight: bold;
}

/* ========= ANTD MODAL ========= */
.ant-modal-content,
.ant-modal-header {
	background: #252c36;
}
.ant-modal-title {
	color: white;
	font-weight: bold;
}
.ant-modal {
	width: auto !important;
}
@media (max-width: 767px) {
	.ant-modal-body {
		width: calc(100vw - 50px);
	}
}
.ant-modal-header {
	padding-right: 50px;
}
.ant-modal-wrap.ant-modal-centered {
	overflow: auto;
}

/* ========= ANTD TABLE ========= */
/* MARKER */
mark {
	background: #21f54e !important;
}
/* SEARCH ICON - ACTIVE */
.ant-table-filter-trigger.active .anticon-search svg path {
	color: #1890ff;
}
/* FILTER ICON - ACTIVE */
.ant-table-filter-trigger.active svg path {
	color: #1890ff;
}
/* TABLE CONTAINER */
.ant-table {
	background: transparent;
}
/* EMPTY TABLE ON HOVER */
.ant-table-tbody > tr.ant-table-placeholder:hover > td {
	background: transparent;
}
/* Table HEADER */
.ant-table-thead > tr > th {
	background: transparent;
	font-weight: bold;
	color: white;
}
/* TABLE HEADER HOVER */
.ant-table-thead th.ant-table-column-has-sorters:hover {
	background: #414b53;
}
/* TABLE HEADER ON CLICK SORT BG COLOR */
.ant-table-thead th.ant-table-column-sort {
	background: transparent;
}
/* TABLE CELL */
.ant-table-cell {
	background: transparent;
}
/* TABLE CELL ON CLICK SORT BG COLOR */
td.ant-table-column-sort {
	background: transparent;
}
/* TABLE ROW HOVER */
.ant-table-tbody > tr.ant-table-row:hover > td,
.ant-table-tbody > tr > td.ant-table-cell-row-hover {
	background: #414b53;
}
/* TABLE ROW BORDERS */
.ant-table-tbody > tr > td {
	border-bottom: 1px solid #414b53;
}
/* ANT TABLE SEARCH BOX */
.ant-table-filter-dropdown {
	border-radius: 8px;
}
/* ANTD TABLE COLUMNS SEPARATOR */
.ant-table-thead
	> tr
	> th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
	background-color: rgb(201 201 201 / 24%);
}
/* ANTD TABLE EXPANDED */
tr.ant-table-expanded-row:hover > td,
tr.ant-table-expanded-row > td {
	background: #3f464e54;
}
/* ANTD TABLE EXPANDED BUTTONS */
.ant-table-row-expand-icon-cell .ant-table-row-expand-icon {
	background: transparent;
}
.ant-table-row-expand-icon:hover {
	border-color: white;
	color: white;
}
/* ANT TABLE FILTER DROPDOWN */
.ant-dropdown-menu {
	background: rgb(81, 93, 106);
}
.ant-table-filter-dropdown {
	background: rgb(81, 93, 106);
}
.ant-input-affix-wrapper {
	background: #464f5b;
	border: 1px solid #464f5b;
}
.ant-table-filter-dropdown-search-input > input:hover {
	border-color: #464f5b !important;
}
.ant-table-filter-dropdown-search {
	border-bottom: 1px solid #606f7a;
}
.ant-table-filter-dropdown-btns {
	border-top: 1px solid #606f7a;
}
.ant-dropdown-menu-item:hover {
	background: #414b53;
}
.ant-dropdown-menu-item-selected {
	background: #414b53;
}
/* TABLE W/ CHECKBOX - SELECTED BG COLOR */
tr.ant-table-row-selected > td {
	background: #444d59 !important;
}
/* TABLE SORTER - COLORS WHEN ACTIVE */
.ant-table-column-sorter-down.active svg {
	color: #1890ff !important;
}
.ant-table-column-sorter-up.active svg {
	color: #1890ff !important;
}
.ant-table-column-sorter-up.active svg path {
	color: inherit !important;
}
.ant-table-column-sorter-down.active svg path {
	color: inherit !important;
}
/* ========= ANTD BUTTONS ========= */
/* TABLE RESET SEARCH BUTTON */
/* .ant-btn-default span {
	color: black;
} */
/* PAGINATION BUTTONS */
.ant-pagination-item-link {
	background: #37404a !important;
	border: 1px solid #3d444c !important;
}
.ant-pagination-item {
	background: #414b53;
	border: 1px solid #414b53;
}
.ant-pagination-item-active {
	background: #2e3236;
	border: 1px solid #2e3236;
}
.ant-pagination-item > a {
	color: white;
}
.ant-pagination-item > a:hover {
	color: white;
}
.ant-pagination-item:hover {
	background: #2e3236;
	border-color: #2e3236;
}
.ant-select:not(.ant-select-customize-input) .ant-select-selector {
	background: #414b53;
	border: 1px solid #414b53;
}
.ant-select-dropdown {
	background: #414b53;
}
.ant-select-item-option-selected {
	background: #2e3236 !important;
}
.ant-select-item-option-active {
	background: #2e3236 !important;
}
.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
	border: 1px solid #414b53 !important;
	box-shadow: none;
}
.ant-pagination-item-active:hover a {
	color: white;
}
.ant-pagination-item:hover a {
	color: white;
}
/* ANTD - PAGINATION ... AND >> */
.ant-pagination-item-link {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
}
.ant-pagination-item-ellipsis {
	top: auto !important;
	top: initial !important;
	right: auto !important;
	right: initial !important;
	left: -45% !important;
	color: #ffffffab !important;
}
/* ANTD INPUT */
.ant-input {
	color: white;
}

/* ANTD Cards */
.ant-card-head {
	padding: 0 24px;
	color: rgba(0, 0, 0, 0.85);
	font-weight: 500;
	font-size: 16px;
	border-radius: 2px 2px 0 0;
	background-color: #3e464e;
	/* border: 1px solid #3e464e; */
}

.ant-tabs-dropdown-menu {
    background-color: #3e464e !important; /* Ensure this has higher specificity */
}

.ant-tabs-dropdown-menu-item:hover {
	background-color: #555b62 !important;
  }

.ant-card-bordered {
	border: transparent;
}

.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
	color: #a0abb4;
	text-shadow: 0 0 0.25px currentcolor;
}

.ant-card-body {
	padding: 24px;
	background-color: #333a40;
	margin-top: -2px;
}
ant-tabs-bottom > .ant-tabs-nav:before,
.ant-tabs-bottom > div > .ant-tabs-nav:before,
.ant-tabs-top > .ant-tabs-nav:before,
.ant-tabs-top > div > .ant-tabs-nav:before {
	position: absolute;
	right: 0;
	left: 0;
	border-bottom: 1px solid #333a40;
	content: "";
}

.ant-card {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	color: rgba(0, 0, 0, 0.85);
	font-size: 14px;
	font-variant: tabular-nums;
	line-height: 1.5715;
	list-style: none;
	font-feature-settings: "tnum";
	position: relative;
	background: #333a40;
	border-radius: 5px;
}

/* ================ ANTD DATE PICKER ================ */
/* Container */
.ant-picker-panel-container {
	background: #333a40;
}
/* Day of the week */
.ant-picker-date-panel .ant-picker-content th {
	color: #1890ff;
	text-align: center;
}
/* On date picker hover */
.ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,
.ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end)
	.ant-picker-cell-inner {
	background-color: #282d30;
}
/* Date input */
.ant-picker {
	background: rgb(70, 79, 91);
	border-color: transparent;
	border-radius: 0;
	width: 100%;
}
.ant-picker:hover {
	border-color: #0372aa !important;
}
.ant-picker-input > input {
	color: white;
}
.ant-picker-input > input:hover,
.ant-picker-input > input:focus {
	border-color: transparent !important;
}
.ant-picker-clear {
	background: rgb(70, 79, 91);
}
/* If Disabled */
.ant-picker-input > input[disabled] {
	background: rgb(57, 64, 73) !important;
	color: rgb(199, 199, 199);
}
.ant-picker.ant-picker-disabled {
	background: rgb(57, 64, 73) !important;
	border-color: transparent;
}
.ant-picker.ant-picker-disabled:hover {
	border-color: #0372aa;
}
.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):before {
	background: #2e4a74;
}
.ant-picker-cell-in-view.ant-picker-cell-in-range:before {
	background: #215485;
}
.ant-picker-cell-in-range.ant-picker-cell-range-hover:before {
	background: #1e3353 !important;
}
.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after {
	background: #1e3353 !important;
}
.ant-picker-cell-range-hover-end:before {
	background: #1e3353 !important;
}
.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):before {
	background: transparent !important;
}
.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-end-single):before {
	background: transparent !important;
}
.ant-picker-cell-disabled {
	background: rgb(41 42 44 / 38%);
	cursor: not-allowed !important;
	pointer-events: all;
}
.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after {
	background: #215485 !important;
}
.ant-picker-range .ant-picker-active-bar {
	width: 100px !important;
}
.ant-picker-dropdown {
	z-index: 999;
}
@media (max-width: 690px) {
	.ant-picker-panel-container .ant-picker-panels {
		flex-direction: column !important;
	}
}

/* ================ ANTD LIST ================ */
/* List Meta Content */
.ant-list-item-meta-content,
.ant-list-item-meta-title,
.ant-list-item-meta-title > a,
.ant-list-item-meta-description {
	color: white;
}

/* ================ ANTD SEGMENTED ================ */
.ant-segmented-item {
	margin: 0 !important;
}
.ant-segmented-item-selected {
	background: #0b55bd;
}
.ant-segmented-thumb {
	background-color: #0b55bd;
}
.ant-segmented-group {
	box-shadow: 3px 4px 40px 1px rgb(0 0 0 / 30%);
}

/* ================ ANTD COLLAPSE/ACCORDION ================ */
.ant-collapse-borderless {
	background: #333a40;
	margin-bottom: 12px;
}
.ant-collapse-header {
	box-shadow: 1px 1px 10px 1px rgb(0 0 0 / 30%);
	padding: 12px !important;
}
.ant-collapse-content {
	box-shadow: 0px 1px 5px 0px rgb(0 0 0 / 30%);
}
.ant-collapse-content-box {
	padding: 0 !important;
}

/* ============== ANTD - SIDEBAR ============== */
.ant-menu-vertical.ant-menu-sub {
	max-height: 350px;
}
#insideSubmenu .ant-menu-submenu-title {
	background: #0c1728;
	padding-left: 35px !important;
	height: auto !important;
	height: initial !important;
	padding-top: 5px;
	padding-bottom: 5px;
	margin-top: 0;
	margin-bottom: 0;
}
@media (max-width: 900px) and (min-width: 540px) {
	.ant-menu-item-icon {
		width: 100%;
		object-fit: scale-down;
	}
	.ant-menu.ant-menu-inline-collapsed > .ant-menu-item,
	.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
		padding: 0 20px;
	}
	#insideSubmenu .ant-menu-submenu-title {
		display: flex;
		align-items: center;
		padding-left: 20px !important;
	}
	#insideSubmenu .ant-menu-submenu-title .ant-menu-item-icon {
		width: 20px;
		height: 20px;
	}
	.ant-menu-item.ant-menu-item-only-child {
		padding-left: 30px !important;
	}
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
	height: 42px;
}
/* @media only screen and (max-width: 540px) { */
.ant-drawer-content-wrapper {
	height: 100%;
}
.ant-layout-sider {
	min-width: 0 !important;
	min-width: initial !important;
	max-width: none !important;
	max-width: initial !important;
	width: 100% !important;
}

/* =============== ANTD MENU ============== */
.ant-menu-item-selected {
	background: #1890ff !important;
}
svg {
	vertical-align: baseline;
}

/* =============== ANTD PROGRESS BAR ============== */
.ant-progress-show-info .ant-progress-outer {
	margin-right: 0;
	margin-right: initial;
	padding-right: 0;
	padding-right: initial;
}
.ant-progress-text {
	width: auto;
	width: initial;
	color: white;
}

/* =============== ANTD SKELETON ============== */
.ant-skeleton-element {
	width: 100% !important;
}

/* =============== ANTD SELECT - DROPDOWN ============== */
.ant-select {
	border: 1px solid transparent;
	background-color: rgb(70, 79, 91);
	height: 100%;
}
.ant-select:hover {
	border-color: #0372aa;
}
.ant-select-selector {
	height: 100% !important;
	background: transparent !important;
}
.ant-select-selection-search-input {
	height: 100% !important;
}
.ant-select-selection-search-input:focus {
	border-color: transparent !important;
}
.ant-select-selection-item {
	line-height: inherit;
	display: flex;
	align-items: center;
}
.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
	border: 0px solid transparent !important;
	box-shadow: none !important;
}
.ant-select:not(.ant-select-customize-input) .ant-select-selector {
	border: 1px solid transparent !important;
	border-radius: 0;
	border-radius: initial;
}

/* =============== REACT-READ-PDF =============== */
.mobile__pdf__container #viewerContainer {
	position: inherit !important;
}
.mobile__pdf__container #viewerContainer .pdfViewer {
	overflow: hidden !important;
}
.pdfViewer .page {
	margin: 0 !important;
	width: 100% !important;
	border: 0 !important;
}
.mobile__pdf__container #loadingBar {
	display: none;
}

/* ============= WHEN PRINTING PDF's ============ */
@media print {
	/* Hide all elements on the page except for the PDF */
	/* * {
		visibility: hidden;
	} */
	/* Make the PDF the only thing visible on the page */
	/* #pdf-viewer * {
		visibility: visible;
	}
	#pdf-viewer {
		position: fixed;
		top: 0;
		left: 0;
		transform: translate(0, 0);
	} */
}

input[type="checkbox"],
input[type="radio"] {
	height: 20px;
	/* display: flex; */
	margin-top: 10px;
}

.ant-select-multiple .ant-select-selection-item {
	position: relative;
	display: flex;
	flex: none;
	box-sizing: border-box;
	max-width: 100%;
	height: 24px;
	margin-top: 2px;
	margin-bottom: 2px;
	line-height: 22px;
	background: #333a40;
	border: 1px solid transparent;
	border-radius: 2px;
	cursor: default;
	transition: font-size 0.3s, line-height 0.3s, height 0.3s;
	-webkit-user-select: none;
	user-select: none;
	margin-inline-end: 4px;
	padding-inline-start: 8px;
	padding-inline-end: 4px;
}

.ant-drawer-content-wrapper {
	position: relative;
	transition: all 0.3s;
}
textarea.ant-input {
	background-color: #464f5b;
	border: 1px solid transparent;
	color: white;
}

.ant-table-container table > thead > tr:first-child th:last-child {
	border-top-right-radius: 2px;
	width: 10%;
}
/* .ant-upload.ant-upload-select-picture-card {
	width: 104px;
	height: 104px;
	margin-right: 8px;
	margin-bottom: 8px;
	text-align: center;
	vertical-align: top;
	background-color: #fafafa;
	border: 1px dashed #d9d9d9;
	border-radius: 2px;
	cursor: pointer;
	transition: border-color 0.3s;
	background-color: transparent;
} */
/*.ant-btn-default span {
	color: white;
	font-size: 20px;
}
.ant-btn ant-btn-default {
	background-color: transparent;
	border: 2px dashed white;
	color: white;
	height: auto !important;
}*/
/* button,
html [type="button"] {
	background-color: transparent;
	border: 2px dashed white;
	color: white;
	height: auto !important;
}
button,
html [type="button"]:hover {
	background-color: #0595db;
}
button,
html [type="button"]:checked {
	background-color: transparent;
}
button,
html [type="button"]:active {
	background-color: transparent;
}
button,
html [type="span"] {
	background-color: transparent;
} */
.ant-upload-span:hover {
	background-color: #0595db !important;
}

.ant-upload-btn {
	background: none; /* Elimina el fondo del botón por defecto */
}

/* Estilos del botón cuando contiene contenido (después de cargar una foto) */
.ant-upload-btn:not(:empty) {
	background: none; /* Asegúrate de que el fondo siga siendo transparente después de cargar una foto */
}

/* Estilos del botón cuando está en estado activo (haciendo clic) */
.ant-upload-btn:active {
	background: none; /* Asegúrate de que el fondo siga siendo transparente durante el clic */
}
.ant-radio-disabled .ant-radio-inner:after {
	background-color: rgba(0, 0, 7);
}
span.ant-radio + * {
	padding-right: 8px;
	padding-left: 8px;
	color: white;
}
.ant-input-number-handler-wrap {
	position: absolute;
	top: 0;
	right: 0;
	width: 22px;
	height: 100%;
	background: #fff;
	border-radius: 0 2px 2px 0;
	opacity: 0;
	/* transition: opacity .24s linear .1s; */
	background: #333a40;
}
code,
kbd,
pre,
samp {
	font-size: 1em;
	font-family: montserrat, sans-serif;
}
.react-datepicker__input-container > span {
	display: none;
}
mapboxgl-ctrl-geocoder .suggestions {
	font-size: 13px;
	background: rgb(95, 95, 95);
}

@media screen and (min-width: 640px) {
	.mapboxgl-ctrl-geocoder .suggestions {
		font-size: 13px;
		background: rgb(95, 95, 95);
	}
}

/* Toasts da antd (message.success / message.error).
   O \`* { color: white }\` no topo deste ficheiro pinta tambem o texto destes avisos,
   que na antd tem fundo branco por omissao — davam branco sobre branco, ilegiveis.
   Alinhados com o fundo do menu lateral (#0f2030, ver sidebar.js), que ja e escuro
   e combina com o texto branco herdado. */
.ant-message-notice-content {
	background: #0f2030;
	border: 1px solid #1c3a52;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
}

.ant-message-custom-content span {
	color: white;
}
`, "",{"version":3,"sources":["webpack://./src/globals.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,SAAS;CACT,YAAY;CACZ,sBAAsB;CACtB,mCAAmC;AACpC;;AAEA;;;;;;;CAOC,YAAY;AACb;;AAEA;CACC,6BAA6B;CAC7B,iBAAiB;CACjB,yBAAyB;CACzB,2BAA2B;AAC5B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;CACrB,UAAU;CACV,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,yBAAyB;AAC1B;AACA;CACC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,wCAAwC;CACxC,iBAAiB;CACjB,oCAAoC;CACpC,0CAA0C;AAC3C;AACA;CACC,gCAAgC;AACjC;AACA;CACC,gCAAgC;CAChC,UAAU;CACV,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,sCAAsC;CACtC,6BAA6B;CAC7B,oCAAoC;CACpC,8BAA8B;CAC9B,kBAAkB;AACnB;AACA;;CAEC,gCAAgC;AACjC;AACA;;CAEC,aAAa;AACd;AACA;CACC,sCAAsC;CACtC,oCAAoC;CACpC,8BAA8B;CAC9B,oCAAoC;CACpC,2CAA2C;CAC3C,uCAAuC;AACxC;AACA;CACC,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,6BAA6B;CAC7B,iBAAiB;AAClB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;CACrB,UAAU;CACV,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,sCAAsC;CACtC,yBAAyB;CACzB,8BAA8B;AAC/B;AACA;CACC,YAAY;AACb;AACA;CACC,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,uBAAuB;CACvB,iCAAiC;CACjC,cAAc;CACd,sCAAsC;CACtC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,gCAAgC;CAChC,mCAAmC;CACnC,mBAAmB;CACnB,+BAA+B;CAC/B,qCAAqC;CACrC,aAAa;CACb,kBAAkB;CAClB,cAAc;CACd,eAAe;AAChB;AACA;CACC,YAAY;CACZ,YAAY;AACb;AACA;CACC,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,eAAe;AAChB;AACA;CACC,WAAW;CACX,6BAA6B;CAC7B,iBAAiB;CACjB,yBAAyB;AAC1B;AACA;CACC,wCAAwC;CACxC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,gBAAgB;CAChB,YAAY;CACZ,6BAA6B;AAC9B;AACA;CACC,iBAAiB;CACjB,eAAe;AAChB;AACA;CACC,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,iBAAiB;CACjB,WAAW;CACX,iBAAiB;CACjB,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,aAAa;AACd;AACA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,YAAY;AACb,EAAE,YAAY;AACd;CACC,iBAAiB;AAClB;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA,mDAAmD;AACnD;;;;;;;;;;;;;;GAcG;AACH;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,wBAAwB;AACzB;AACA,8CAA8C;AAC9C;CACC,yBAAyB;AAC1B;AACA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,YAAY;CACZ,iCAAiC;AAClC;AACA;CACC,YAAY;CACZ,0BAA0B;CAC1B,4BAA4B;CAC5B,8CAA8C;AAC/C;AACA;CACC,aAAa;AACd;AACA;CACC,iCAAiC;AAClC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;CACX,eAAgB;CAAhB,kBAAgB;AACjB;AACA;CACC,oBAAoB;CACpB,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;AACpB;AACA,4CAA4C;AAC5C;CACC,+CAA+C;CAC/C,WAAW;CACX,4GAA4G;CAC5G,oCAAoC;CACpC,wBAAwB;AACzB;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AACA;CACC,2BAA2B;CAC3B,iCAAiC;AAClC;AACA,4CAA4C;AAC5C;CACC,yBAAyB;AAC1B;AACA;CACC,YAAY;CACZ,iBAAiB;AAClB;;AAEA,mCAAmC;AACnC;;CAEC,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,sBAAsB;AACvB;AACA;CACC;EACC,yBAAyB;CAC1B;AACD;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;;AAEA,mCAAmC;AACnC,WAAW;AACX;CACC,8BAA8B;AAC/B;AACA,yBAAyB;AACzB;CACC,cAAc;AACf;AACA,yBAAyB;AACzB;CACC,cAAc;AACf;AACA,oBAAoB;AACpB;CACC,uBAAuB;AACxB;AACA,yBAAyB;AACzB;CACC,uBAAuB;AACxB;AACA,iBAAiB;AACjB;CACC,uBAAuB;CACvB,iBAAiB;CACjB,YAAY;AACb;AACA,uBAAuB;AACvB;CACC,mBAAmB;AACpB;AACA,wCAAwC;AACxC;CACC,uBAAuB;AACxB;AACA,eAAe;AACf;CACC,uBAAuB;AACxB;AACA,sCAAsC;AACtC;CACC,uBAAuB;AACxB;AACA,oBAAoB;AACpB;;CAEC,mBAAmB;AACpB;AACA,sBAAsB;AACtB;CACC,gCAAgC;AACjC;AACA,yBAAyB;AACzB;CACC,kBAAkB;AACnB;AACA,iCAAiC;AACjC;;;CAGC,wCAAwC;AACzC;AACA,wBAAwB;AACxB;;CAEC,qBAAqB;AACtB;AACA,gCAAgC;AAChC;CACC,uBAAuB;AACxB;AACA;CACC,mBAAmB;CACnB,YAAY;AACb;AACA,8BAA8B;AAC9B;CACC,4BAA4B;AAC7B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,mBAAmB;CACnB,yBAAyB;AAC1B;AACA;CACC,gCAAgC;AACjC;AACA;CACC,gCAAgC;AACjC;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA,0CAA0C;AAC1C;CACC,8BAA8B;AAC/B;AACA,sCAAsC;AACtC;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAuB;AACxB;AACA;CACC,yBAAuB;AACxB;AACA,qCAAqC;AACrC,8BAA8B;AAC9B;;GAEG;AACH,uBAAuB;AACvB;CACC,8BAA8B;CAC9B,oCAAoC;AACrC;AACA;CACC,mBAAmB;CACnB,yBAAyB;AAC1B;AACA;CACC,mBAAmB;CACnB,yBAAyB;AAC1B;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,yBAAyB;AAC1B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,oCAAoC;CACpC,gBAAgB;AACjB;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA,iCAAiC;AACjC;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,oBAAqB;CAArB,uBAAqB;CACrB,sBAAuB;CAAvB,yBAAuB;CACvB,qBAAqB;CACrB,2BAA2B;AAC5B;AACA,eAAe;AACf;CACC,YAAY;AACb;;AAEA,eAAe;AACf;CACC,eAAe;CACf,0BAA0B;CAC1B,gBAAgB;CAChB,eAAe;CACf,0BAA0B;CAC1B,yBAAyB;CACzB,+BAA+B;AAChC;;AAEA;IACI,oCAAoC,EAAE,uCAAuC;AACjF;;AAEA;CACC,oCAAoC;EACnC;;AAEF;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,oCAAoC;AACrC;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,gBAAgB;AACjB;AACA;;;;CAIC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,gCAAgC;CAChC,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,SAAS;CACT,UAAU;CACV,0BAA0B;CAC1B,eAAe;CACf,0BAA0B;CAC1B,mBAAmB;CACnB,gBAAgB;CAChB,6BAA6B;CAC7B,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA,uDAAuD;AACvD,cAAc;AACd;CACC,mBAAmB;AACpB;AACA,oBAAoB;AACpB;CACC,cAAc;CACd,kBAAkB;AACnB;AACA,yBAAyB;AACzB;;;CAGC,yBAAyB;AAC1B;AACA,eAAe;AACf;CACC,2BAA2B;CAC3B,yBAAyB;CACzB,gBAAgB;CAChB,WAAW;AACZ;AACA;CACC,gCAAgC;AACjC;AACA;CACC,YAAY;AACb;AACA;;CAEC,oCAAoC;AACrC;AACA;CACC,2BAA2B;AAC5B;AACA,gBAAgB;AAChB;CACC,sCAAsC;CACtC,yBAAyB;AAC1B;AACA;CACC,sCAAsC;CACtC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,kCAAkC;AACnC;AACA;CACC,kCAAkC;AACnC;AACA;CACC,+BAA+B;CAC/B,8BAA8B;CAC9B,mBAAmB;AACpB;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,uBAAuB;AACxB;AACA;CACC,YAAY;AACb;AACA;CACC;EACC,iCAAiC;CAClC;AACD;;AAEA,gDAAgD;AAChD,sBAAsB;AACtB;;;;CAIC,YAAY;AACb;;AAEA,qDAAqD;AACrD;CACC,oBAAoB;AACrB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,6CAA6C;AAC9C;;AAEA,8DAA8D;AAC9D;CACC,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,6CAA6C;CAC7C,wBAAwB;AACzB;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,qBAAqB;AACtB;;AAEA,iDAAiD;AACjD;CACC,iBAAiB;AAClB;AACA;CACC,mBAAmB;CACnB,6BAA6B;CAC7B,uBAAwB;CAAxB,0BAAwB;CACxB,gBAAgB;CAChB,mBAAmB;CACnB,aAAa;CACb,gBAAgB;AACjB;AACA;CACC;EACC,WAAW;EACX,sBAAsB;CACvB;CACA;;EAEC,eAAe;CAChB;CACA;EACC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;CAC9B;CACA;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,6BAA6B;CAC9B;AACD;AACA;CACC,YAAY;AACb;AACA,gDAAgD;AAChD;CACC,YAAY;AACb;AACA;CACC,uBAA2B;CAA3B,6BAA2B;CAC3B,0BAA2B;CAA3B,6BAA2B;CAC3B,sBAAsB;AACvB;;AAEA,6CAA6C;AAC7C;CACC,8BAA8B;AAC/B;AACA;CACC,wBAAwB;AACzB;;AAEA,qDAAqD;AACrD;CACC,eAAmB;CAAnB,qBAAmB;CACnB,gBAAoB;CAApB,sBAAoB;AACrB;AACA;CACC,WAAY;CAAZ,cAAY;CACZ,YAAY;AACb;;AAEA,iDAAiD;AACjD;CACC,sBAAsB;AACvB;;AAEA,0DAA0D;AAC1D;CACC,6BAA6B;CAC7B,iCAAiC;CACjC,YAAY;AACb;AACA;CACC,qBAAqB;AACtB;AACA;CACC,uBAAuB;CACvB,kCAAkC;AACnC;AACA;CACC,uBAAuB;AACxB;AACA;CACC,oCAAoC;AACrC;AACA;CACC,oBAAkB;CAClB,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,wCAAwC;CACxC,2BAA2B;AAC5B;AACA;CACC,wCAAwC;CACxC,gBAAoB;CAApB,sBAAoB;AACrB;;AAEA,mDAAmD;AACnD;CACC,4BAA4B;AAC7B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,oBAAoB;CACpB,sBAAsB;CACtB,oBAAoB;AACrB;AACA;CACC,aAAa;AACd;;AAEA,mDAAmD;AACnD;CACC,qDAAqD;CACrD;;IAEG;CACH,oDAAoD;CACpD;;;;;;;;IAQG;AACJ;;AAEA;;CAEC,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,UAAU;CACV,sBAAsB;CACtB,eAAe;CACf,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;CACnB,6BAA6B;CAC7B,kBAAkB;CAClB,eAAe;CACf,yDAAyD;CACzD,yBAAyB;CAGzB,iBAAiB;CAEjB,sBAAsB;CAEtB,yBAAyB;CAEzB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,yBAAyB;CACzB,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,4BAA4B;CAC5B,UAAU;AACX;AACA;;;;;;;;;;;;;GAaG;AACH;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;;;;;;;;GAsBG;AACH;CACC,oCAAoC;AACrC;;AAEA;CACC,gBAAgB,EAAE,2CAA2C;AAC9D;;AAEA,6EAA6E;AAC7E;CACC,gBAAgB,EAAE,kFAAkF;AACrG;;AAEA,mEAAmE;AACnE;CACC,gBAAgB,EAAE,uEAAuE;AAC1F;AACA;CACC,+BAA+B;AAChC;AACA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,0BAA0B;CAC1B,UAAU;CACV,yCAAyC;CACzC,mBAAmB;AACpB;AACA;;;;CAIC,cAAc;CACd,mCAAmC;AACpC;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC;EACC,eAAe;EACf,2BAA2B;CAC5B;AACD;;AAEA;;;;0CAI0C;AAC1C;CACC,mBAAmB;CACnB,yBAAyB;CACzB,0CAA0C;AAC3C;;AAEA;CACC,YAAY;AACb","sourcesContent":["* {\n\tcolor: white;\n\tmargin: 0;\n\tpadding: 0px;\n\tbox-sizing: border-box;\n\tfont-family: montserrat, sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\na {\n\tcolor: white;\n}\n\ntextarea {\n\tborder: 1px solid transparent;\n\tpadding-left: 5px;\n\tbackground-color: #464f5b;\n\tmin-height: 80px !important;\n}\ntextarea:hover {\n\tborder-color: #0595db;\n}\ntextarea:focus {\n\tborder-color: #0595db;\n\toutline: 0;\n\tbackground-color: #464f5b;\n\tbox-shadow: none;\n}\ntextarea.ant-input {\n\tcolor: black;\n\tbackground-color: #e8eaed;\n}\ntextarea.ant-input:focus {\n\tcolor: white;\n\tbackground-color: #464f5b;\n}\n\nlabel {\n\tfont-weight: 200;\n\tfont-size: 16px;\n}\n\ninput {\n\theight: 35px;\n\tborder: 1px solid transparent !important;\n\tpadding-left: 5px;\n\tbackground-color: #464f5b !important;\n\tborder-right-color: transparent !important;\n}\ninput:hover {\n\tborder-color: #0372aa !important;\n}\ninput:focus {\n\tborder-color: #0372aa !important;\n\toutline: 0;\n\tbackground-color: #464f5b;\n\tbox-shadow: none;\n}\ninput:-webkit-autofill {\n\tbox-shadow: 0 0 0 1000px #464f5b inset;\n\tborder: 1px solid transparent;\n\t-webkit-background-clip: content-box;\n\t-webkit-text-fill-color: white;\n\tcaret-color: white;\n}\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus {\n\tborder-color: #0372aa !important;\n}\ninput::-ms-reveal,\ninput::-ms-clear {\n\tdisplay: none;\n}\ninput[disabled] {\n\tbackground: rgb(57, 64, 73) !important;\n\tcolor: rgb(199, 199, 199) !important;\n\tcursor: not-allowed !important;\n\tborder-color: transparent !important;\n\t-webkit-text-fill-color: rgb(199, 199, 199);\n\tbackground-clip: padding-box !important;\n}\ninput[disabled]:hover {\n\tborder-color: #0372aa !important;\n}\n\nselect {\n\tbackground-color: #464f5b;\n\theight: 35px;\n\tborder: 1px solid transparent;\n\tpadding-left: 5px;\n}\nselect:hover {\n\tborder-color: #0372aa;\n}\nselect:focus {\n\tborder-color: #0595db;\n\toutline: 0;\n\tbackground-color: #464f5b;\n\tbox-shadow: none;\n}\nselect[disabled] {\n\tbackground: rgb(57, 64, 73) !important;\n\tcolor: rgb(199, 199, 199);\n\tcursor: not-allowed !important;\n}\noption {\n\tborder: none;\n}\n.App {\n\t/* height: 100vh; */\n\tdisplay: flex;\n\talign-items: center;\n\tflex-direction: column;\n\tjustify-content: center;\n\tbackground-color: rgb(57, 64, 73);\n\twidth: inherit;\n\t/* scrollbar-color: #6969dd #e0e0e0; */\n\t/* scrollbar-width: thin; */\n}\n\n.AppMain {\n\tdisplay: flex;\n\twidth: 100%;\n\t/* height: inherit; */\n}\n\n.rootContainer {\n\theight: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\nbutton {\n\tcursor: pointer;\n\tborder: 0;\n\tfont-size: 16px;\n}\n\n.rmsc {\n\t--rmsc-main: #3a09e7d0;\n\t--rmsc-hover: rgb(119, 123, 128);\n\t--rmsc-selected: rgb(103, 110, 121);\n\t--rmsc-border: #333;\n\t--rmsc-gray: rgb(255, 255, 255);\n\t--rmsc-bg: rgb(70, 79, 91) !important;\n\t--rmsc-p: 5px;\n\t--rmsc-radius: 0px;\n\t--rmsc-h: 36px;\n\tmargin-top: 3px;\n}\n.dropdown-content span {\n\tcolor: white;\n\tz-index: 999;\n}\n.dropdown-content input {\n\tcolor: white;\n\tmax-width: 10%;\n}\n\n.dropdown-heading-value {\n\toverflow: visible !important;\n}\n\n.dropdown-heading-value span {\n\tcolor: white;\n\tfont-size: 12px;\n}\n\n.LineFormNewStructure .form-control {\n\twidth: 100% !important;\n\tmargin-top: 5px;\n}\n::-webkit-scrollbar {\n\twidth: 10px;\n\tbackground-color: transparent;\n\tmargin-left: 20px;\n\tbackground-color: #202c38;\n}\n::-webkit-scrollbar-track {\n\t/* background: transparent !important; */\n\tbackground: #202c38;\n}\n::-webkit-scrollbar-thumb {\n\tbackground: #464f5b;\n}\n::-webkit-scrollbar-thumb:hover {\n\tbackground: #555;\n}\n\na:focus {\n\ttext-decoration: none;\n\tcolor: white;\n}\n.tooltip {\n\twidth: 250px;\n}\n#menu * {\n\tlist-style: none;\n\tcolor: black;\n\tbackground-color: transparent;\n}\n#menu li {\n\tline-height: 130%;\n\tfont-size: 24px;\n}\n#menu li a {\n\tcolor: #222;\n\ttext-decoration: none;\n\tfont-size: 16px;\n\tline-height: 0px;\n\tmargin-bottom: 20px;\n}\n#menu li a:before {\n\tcontent: \"\\025b8\";\n\tcolor: #ddd;\n\tmargin-right: 6px;\n\tdisplay: none;\n}\n#menu input[name=\"list\"] {\n\tposition: absolute;\n\tleft: -1000em;\n}\n#menu label:before {\n\tcontent: \"\\025b8\";\n\tmargin-right: 4px;\n\tcolor: black;\n} /* viñetas */\n#menu input:checked ~ label:before {\n\tcontent: \"\\025be\";\n}\n#menu .interior {\n\tdisplay: none;\n}\n#menu input:checked ~ ul {\n\tdisplay: block;\n}\n#menu div {\n\tcolor: #222;\n\ttext-decoration: none;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tmargin-bottom: 10px;\n}\n\n.select-item {\n\tbackground-color: #464f5b !important;\n}\n\n.item-renderer {\n\talign-items: center !important;\n}\n\n.dropdown-container {\n\tborder-color: #464f5b !important;\n}\n\n@media only screen and (max-width: 360px) {\n\t.dropdown-heading-value span {\n\t\tfont-size: 9px;\n\t}\n}\n\n/* ================ MAPBOX - MAP ================ */\n/* .mapboxgl-canvas {\n\theight: unset !important;\n\tmax-width: 100%;\n\tmin-height: 650px;\n\tposition: relative !important;\n}\n@media only screen and (max-width: 540px) {\n\t.mapboxgl-canvas {\n\t\tmin-height: 340px;\n\t\tmax-height: 340px;\n\t}\n}\n.mapboxgl-map {\n\theight: unset !important;\n} */\n#mapContainer {\n\tmin-height: 340px;\n}\n.mapboxgl-map {\n\tmin-height: 340px;\n}\n.mapboxgl-ctrl-bottom-right {\n\tdisplay: none;\n}\na.mapboxgl-ctrl-logo {\n\tdisplay: none;\n}\n.mapboxgl-ctrl-geocoder--powered-by {\n\tdisplay: none !important;\n}\n/* ========= MAPBOX GEOCODER INPUT ========= */\n.mapboxgl-ctrl-geocoder .suggestions {\n\tbackground-color: #37404a;\n}\n.suggestions > .active > a {\n\tbackground-color: #5a6167 !important;\n}\n.suggestions > li > a:hover {\n\tbackground-color: #5a6167 !important;\n}\n.mapboxgl-ctrl-geocoder.mapboxgl-ctrl > input {\n\tcolor: white;\n\tbackground-color: rgb(70, 79, 91);\n}\n.mapboxgl-ctrl-geocoder--input {\n\theight: 35px;\n\tfont-size: 14px !important;\n\tpadding: 6px 40px !important;\n\tfont-family: montserrat, sans-serif !important;\n}\n.mapboxgl-ctrl-geocoder--input:focus {\n\toutline: none;\n}\n.mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--pin-right > * {\n\tbackground-color: rgb(70, 79, 91);\n}\n.mapboxgl-ctrl button:not(:disabled):hover {\n\tbackground-color: rgb(70, 79, 91);\n}\n.mapboxgl-ctrl-geocoder--icon {\n\tfill: white;\n}\n.mapboxgl-ctrl-geocoder.mapboxgl-ctrl {\n\twidth: 100%;\n\tmax-width: unset;\n}\n.mapboxgl-ctrl-geocoder--icon-search {\n\tleft: 7px !important;\n\twidth: 20px !important;\n\theight: 20px !important;\n\ttop: 8px !important;\n}\n/* ========= MAPBOX POPUP LAYOUT ========= */\n.mapboxgl-popup-content {\n\tbackground-color: rgba(2, 3, 3, 0.8) !important;\n\tcolor: #fff;\n\tbox-shadow: 0px 0px 5px 5px rgba(58, 83, 104, 0.5), inset 0px 0px 25px 5px rgba(58, 83, 104, 0.5) !important;\n\tfont-family: \"Open Sans\", sans-serif;\n\tpadding: 20px !important;\n}\n.mapboxgl-popup-tip {\n\tcolor: rgba(58, 83, 104, 0.8);\n}\n.mapboxgl-popup-close-button {\n\ttop: 5px !important;\n\tright: 10px !important;\n}\n.mapboxgl-popup {\n\tmax-width: 300px !important;\n\t/* writing-mode: horizontal-tb; */\n}\n/* ========= NOTIFICATION - ANTD ========= */\n.ant-notification-notice {\n\tbackground-color: #515d66;\n}\n.ant-notification-notice-message {\n\tcolor: white;\n\tfont-weight: bold;\n}\n\n/* ========= ANTD MODAL ========= */\n.ant-modal-content,\n.ant-modal-header {\n\tbackground: #252c36;\n}\n.ant-modal-title {\n\tcolor: white;\n\tfont-weight: bold;\n}\n.ant-modal {\n\twidth: auto !important;\n}\n@media (max-width: 767px) {\n\t.ant-modal-body {\n\t\twidth: calc(100vw - 50px);\n\t}\n}\n.ant-modal-header {\n\tpadding-right: 50px;\n}\n.ant-modal-wrap.ant-modal-centered {\n\toverflow: auto;\n}\n\n/* ========= ANTD TABLE ========= */\n/* MARKER */\nmark {\n\tbackground: #21f54e !important;\n}\n/* SEARCH ICON - ACTIVE */\n.ant-table-filter-trigger.active .anticon-search svg path {\n\tcolor: #1890ff;\n}\n/* FILTER ICON - ACTIVE */\n.ant-table-filter-trigger.active svg path {\n\tcolor: #1890ff;\n}\n/* TABLE CONTAINER */\n.ant-table {\n\tbackground: transparent;\n}\n/* EMPTY TABLE ON HOVER */\n.ant-table-tbody > tr.ant-table-placeholder:hover > td {\n\tbackground: transparent;\n}\n/* Table HEADER */\n.ant-table-thead > tr > th {\n\tbackground: transparent;\n\tfont-weight: bold;\n\tcolor: white;\n}\n/* TABLE HEADER HOVER */\n.ant-table-thead th.ant-table-column-has-sorters:hover {\n\tbackground: #414b53;\n}\n/* TABLE HEADER ON CLICK SORT BG COLOR */\n.ant-table-thead th.ant-table-column-sort {\n\tbackground: transparent;\n}\n/* TABLE CELL */\n.ant-table-cell {\n\tbackground: transparent;\n}\n/* TABLE CELL ON CLICK SORT BG COLOR */\ntd.ant-table-column-sort {\n\tbackground: transparent;\n}\n/* TABLE ROW HOVER */\n.ant-table-tbody > tr.ant-table-row:hover > td,\n.ant-table-tbody > tr > td.ant-table-cell-row-hover {\n\tbackground: #414b53;\n}\n/* TABLE ROW BORDERS */\n.ant-table-tbody > tr > td {\n\tborder-bottom: 1px solid #414b53;\n}\n/* ANT TABLE SEARCH BOX */\n.ant-table-filter-dropdown {\n\tborder-radius: 8px;\n}\n/* ANTD TABLE COLUMNS SEPARATOR */\n.ant-table-thead\n\t> tr\n\t> th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n\tbackground-color: rgb(201 201 201 / 24%);\n}\n/* ANTD TABLE EXPANDED */\ntr.ant-table-expanded-row:hover > td,\ntr.ant-table-expanded-row > td {\n\tbackground: #3f464e54;\n}\n/* ANTD TABLE EXPANDED BUTTONS */\n.ant-table-row-expand-icon-cell .ant-table-row-expand-icon {\n\tbackground: transparent;\n}\n.ant-table-row-expand-icon:hover {\n\tborder-color: white;\n\tcolor: white;\n}\n/* ANT TABLE FILTER DROPDOWN */\n.ant-dropdown-menu {\n\tbackground: rgb(81, 93, 106);\n}\n.ant-table-filter-dropdown {\n\tbackground: rgb(81, 93, 106);\n}\n.ant-input-affix-wrapper {\n\tbackground: #464f5b;\n\tborder: 1px solid #464f5b;\n}\n.ant-table-filter-dropdown-search-input > input:hover {\n\tborder-color: #464f5b !important;\n}\n.ant-table-filter-dropdown-search {\n\tborder-bottom: 1px solid #606f7a;\n}\n.ant-table-filter-dropdown-btns {\n\tborder-top: 1px solid #606f7a;\n}\n.ant-dropdown-menu-item:hover {\n\tbackground: #414b53;\n}\n.ant-dropdown-menu-item-selected {\n\tbackground: #414b53;\n}\n/* TABLE W/ CHECKBOX - SELECTED BG COLOR */\ntr.ant-table-row-selected > td {\n\tbackground: #444d59 !important;\n}\n/* TABLE SORTER - COLORS WHEN ACTIVE */\n.ant-table-column-sorter-down.active svg {\n\tcolor: #1890ff !important;\n}\n.ant-table-column-sorter-up.active svg {\n\tcolor: #1890ff !important;\n}\n.ant-table-column-sorter-up.active svg path {\n\tcolor: unset !important;\n}\n.ant-table-column-sorter-down.active svg path {\n\tcolor: unset !important;\n}\n/* ========= ANTD BUTTONS ========= */\n/* TABLE RESET SEARCH BUTTON */\n/* .ant-btn-default span {\n\tcolor: black;\n} */\n/* PAGINATION BUTTONS */\n.ant-pagination-item-link {\n\tbackground: #37404a !important;\n\tborder: 1px solid #3d444c !important;\n}\n.ant-pagination-item {\n\tbackground: #414b53;\n\tborder: 1px solid #414b53;\n}\n.ant-pagination-item-active {\n\tbackground: #2e3236;\n\tborder: 1px solid #2e3236;\n}\n.ant-pagination-item > a {\n\tcolor: white;\n}\n.ant-pagination-item > a:hover {\n\tcolor: white;\n}\n.ant-pagination-item:hover {\n\tbackground: #2e3236;\n\tborder-color: #2e3236;\n}\n.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n\tbackground: #414b53;\n\tborder: 1px solid #414b53;\n}\n.ant-select-dropdown {\n\tbackground: #414b53;\n}\n.ant-select-item-option-selected {\n\tbackground: #2e3236 !important;\n}\n.ant-select-item-option-active {\n\tbackground: #2e3236 !important;\n}\n.ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n\tborder: 1px solid #414b53 !important;\n\tbox-shadow: none;\n}\n.ant-pagination-item-active:hover a {\n\tcolor: white;\n}\n.ant-pagination-item:hover a {\n\tcolor: white;\n}\n/* ANTD - PAGINATION ... AND >> */\n.ant-pagination-item-link {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-align: center;\n}\n.ant-pagination-item-ellipsis {\n\ttop: unset !important;\n\tright: unset !important;\n\tleft: -45% !important;\n\tcolor: #ffffffab !important;\n}\n/* ANTD INPUT */\n.ant-input {\n\tcolor: white;\n}\n\n/* ANTD Cards */\n.ant-card-head {\n\tpadding: 0 24px;\n\tcolor: rgba(0, 0, 0, 0.85);\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tborder-radius: 2px 2px 0 0;\n\tbackground-color: #3e464e;\n\t/* border: 1px solid #3e464e; */\n}\n\n.ant-tabs-dropdown-menu {\n    background-color: #3e464e !important; /* Ensure this has higher specificity */\n}\n\n.ant-tabs-dropdown-menu-item:hover {\n\tbackground-color: #555b62 !important;\n  }\n\n.ant-card-bordered {\n\tborder: transparent;\n}\n\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n\tcolor: #a0abb4;\n\ttext-shadow: 0 0 0.25px currentcolor;\n}\n\n.ant-card-body {\n\tpadding: 24px;\n\tbackground-color: #333a40;\n\tmargin-top: -2px;\n}\nant-tabs-bottom > .ant-tabs-nav:before,\n.ant-tabs-bottom > div > .ant-tabs-nav:before,\n.ant-tabs-top > .ant-tabs-nav:before,\n.ant-tabs-top > div > .ant-tabs-nav:before {\n\tposition: absolute;\n\tright: 0;\n\tleft: 0;\n\tborder-bottom: 1px solid #333a40;\n\tcontent: \"\";\n}\n\n.ant-card {\n\tbox-sizing: border-box;\n\tmargin: 0;\n\tpadding: 0;\n\tcolor: rgba(0, 0, 0, 0.85);\n\tfont-size: 14px;\n\tfont-variant: tabular-nums;\n\tline-height: 1.5715;\n\tlist-style: none;\n\tfont-feature-settings: \"tnum\";\n\tposition: relative;\n\tbackground: #333a40;\n\tborder-radius: 5px;\n}\n\n/* ================ ANTD DATE PICKER ================ */\n/* Container */\n.ant-picker-panel-container {\n\tbackground: #333a40;\n}\n/* Day of the week */\n.ant-picker-date-panel .ant-picker-content th {\n\tcolor: #1890ff;\n\ttext-align: center;\n}\n/* On date picker hover */\n.ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,\n.ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end)\n\t.ant-picker-cell-inner {\n\tbackground-color: #282d30;\n}\n/* Date input */\n.ant-picker {\n\tbackground: rgb(70, 79, 91);\n\tborder-color: transparent;\n\tborder-radius: 0;\n\twidth: 100%;\n}\n.ant-picker:hover {\n\tborder-color: #0372aa !important;\n}\n.ant-picker-input > input {\n\tcolor: white;\n}\n.ant-picker-input > input:hover,\n.ant-picker-input > input:focus {\n\tborder-color: transparent !important;\n}\n.ant-picker-clear {\n\tbackground: rgb(70, 79, 91);\n}\n/* If Disabled */\n.ant-picker-input > input[disabled] {\n\tbackground: rgb(57, 64, 73) !important;\n\tcolor: rgb(199, 199, 199);\n}\n.ant-picker.ant-picker-disabled {\n\tbackground: rgb(57, 64, 73) !important;\n\tborder-color: transparent;\n}\n.ant-picker.ant-picker-disabled:hover {\n\tborder-color: #0372aa;\n}\n.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):before {\n\tbackground: #2e4a74;\n}\n.ant-picker-cell-in-view.ant-picker-cell-in-range:before {\n\tbackground: #215485;\n}\n.ant-picker-cell-in-range.ant-picker-cell-range-hover:before {\n\tbackground: #1e3353 !important;\n}\n.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after {\n\tbackground: #1e3353 !important;\n}\n.ant-picker-cell-range-hover-end:before {\n\tbackground: #1e3353 !important;\n}\n.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single):before {\n\tbackground: transparent !important;\n}\n.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-end-single):before {\n\tbackground: transparent !important;\n}\n.ant-picker-cell-disabled {\n\tbackground: rgb(41 42 44 / 38%);\n\tcursor: not-allowed !important;\n\tpointer-events: all;\n}\n.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after {\n\tbackground: #215485 !important;\n}\n.ant-picker-range .ant-picker-active-bar {\n\twidth: 100px !important;\n}\n.ant-picker-dropdown {\n\tz-index: 999;\n}\n@media (max-width: 690px) {\n\t.ant-picker-panel-container .ant-picker-panels {\n\t\tflex-direction: column !important;\n\t}\n}\n\n/* ================ ANTD LIST ================ */\n/* List Meta Content */\n.ant-list-item-meta-content,\n.ant-list-item-meta-title,\n.ant-list-item-meta-title > a,\n.ant-list-item-meta-description {\n\tcolor: white;\n}\n\n/* ================ ANTD SEGMENTED ================ */\n.ant-segmented-item {\n\tmargin: 0 !important;\n}\n.ant-segmented-item-selected {\n\tbackground: #0b55bd;\n}\n.ant-segmented-thumb {\n\tbackground-color: #0b55bd;\n}\n.ant-segmented-group {\n\tbox-shadow: 3px 4px 40px 1px rgb(0 0 0 / 30%);\n}\n\n/* ================ ANTD COLLAPSE/ACCORDION ================ */\n.ant-collapse-borderless {\n\tbackground: #333a40;\n\tmargin-bottom: 12px;\n}\n.ant-collapse-header {\n\tbox-shadow: 1px 1px 10px 1px rgb(0 0 0 / 30%);\n\tpadding: 12px !important;\n}\n.ant-collapse-content {\n\tbox-shadow: 0px 1px 5px 0px rgb(0 0 0 / 30%);\n}\n.ant-collapse-content-box {\n\tpadding: 0 !important;\n}\n\n/* ============== ANTD - SIDEBAR ============== */\n.ant-menu-vertical.ant-menu-sub {\n\tmax-height: 350px;\n}\n#insideSubmenu .ant-menu-submenu-title {\n\tbackground: #0c1728;\n\tpadding-left: 35px !important;\n\theight: unset !important;\n\tpadding-top: 5px;\n\tpadding-bottom: 5px;\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n}\n@media (max-width: 900px) and (min-width: 540px) {\n\t.ant-menu-item-icon {\n\t\twidth: 100%;\n\t\tobject-fit: scale-down;\n\t}\n\t.ant-menu.ant-menu-inline-collapsed > .ant-menu-item,\n\t.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n\t\tpadding: 0 20px;\n\t}\n\t#insideSubmenu .ant-menu-submenu-title {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding-left: 20px !important;\n\t}\n\t#insideSubmenu .ant-menu-submenu-title .ant-menu-item-icon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n\t.ant-menu-item.ant-menu-item-only-child {\n\t\tpadding-left: 30px !important;\n\t}\n}\n.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {\n\theight: 42px;\n}\n/* @media only screen and (max-width: 540px) { */\n.ant-drawer-content-wrapper {\n\theight: 100%;\n}\n.ant-layout-sider {\n\tmin-width: unset !important;\n\tmax-width: unset !important;\n\twidth: 100% !important;\n}\n\n/* =============== ANTD MENU ============== */\n.ant-menu-item-selected {\n\tbackground: #1890ff !important;\n}\nsvg {\n\tvertical-align: baseline;\n}\n\n/* =============== ANTD PROGRESS BAR ============== */\n.ant-progress-show-info .ant-progress-outer {\n\tmargin-right: unset;\n\tpadding-right: unset;\n}\n.ant-progress-text {\n\twidth: unset;\n\tcolor: white;\n}\n\n/* =============== ANTD SKELETON ============== */\n.ant-skeleton-element {\n\twidth: 100% !important;\n}\n\n/* =============== ANTD SELECT - DROPDOWN ============== */\n.ant-select {\n\tborder: 1px solid transparent;\n\tbackground-color: rgb(70, 79, 91);\n\theight: 100%;\n}\n.ant-select:hover {\n\tborder-color: #0372aa;\n}\n.ant-select-selector {\n\theight: 100% !important;\n\tbackground: transparent !important;\n}\n.ant-select-selection-search-input {\n\theight: 100% !important;\n}\n.ant-select-selection-search-input:focus {\n\tborder-color: transparent !important;\n}\n.ant-select-selection-item {\n\tline-height: unset;\n\tdisplay: flex;\n\talign-items: center;\n}\n.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {\n\tborder: 0px solid transparent !important;\n\tbox-shadow: none !important;\n}\n.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n\tborder: 1px solid transparent !important;\n\tborder-radius: unset;\n}\n\n/* =============== REACT-READ-PDF =============== */\n.mobile__pdf__container #viewerContainer {\n\tposition: inherit !important;\n}\n.mobile__pdf__container #viewerContainer .pdfViewer {\n\toverflow: hidden !important;\n}\n.pdfViewer .page {\n\tmargin: 0 !important;\n\twidth: 100% !important;\n\tborder: 0 !important;\n}\n.mobile__pdf__container #loadingBar {\n\tdisplay: none;\n}\n\n/* ============= WHEN PRINTING PDF's ============ */\n@media print {\n\t/* Hide all elements on the page except for the PDF */\n\t/* * {\n\t\tvisibility: hidden;\n\t} */\n\t/* Make the PDF the only thing visible on the page */\n\t/* #pdf-viewer * {\n\t\tvisibility: visible;\n\t}\n\t#pdf-viewer {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\ttransform: translate(0, 0);\n\t} */\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n\theight: 20px;\n\t/* display: flex; */\n\tmargin-top: 10px;\n}\n\n.ant-select-multiple .ant-select-selection-item {\n\tposition: relative;\n\tdisplay: flex;\n\tflex: none;\n\tbox-sizing: border-box;\n\tmax-width: 100%;\n\theight: 24px;\n\tmargin-top: 2px;\n\tmargin-bottom: 2px;\n\tline-height: 22px;\n\tbackground: #333a40;\n\tborder: 1px solid transparent;\n\tborder-radius: 2px;\n\tcursor: default;\n\ttransition: font-size 0.3s, line-height 0.3s, height 0.3s;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\t-webkit-margin-end: 4px;\n\tmargin-inline-end: 4px;\n\t-webkit-padding-start: 8px;\n\tpadding-inline-start: 8px;\n\t-webkit-padding-end: 4px;\n\tpadding-inline-end: 4px;\n}\n\n.ant-drawer-content-wrapper {\n\tposition: relative;\n\ttransition: all 0.3s;\n}\ntextarea.ant-input {\n\tbackground-color: #464f5b;\n\tborder: 1px solid transparent;\n\tcolor: white;\n}\n\n.ant-table-container table > thead > tr:first-child th:last-child {\n\tborder-top-right-radius: 2px;\n\twidth: 10%;\n}\n/* .ant-upload.ant-upload-select-picture-card {\n\twidth: 104px;\n\theight: 104px;\n\tmargin-right: 8px;\n\tmargin-bottom: 8px;\n\ttext-align: center;\n\tvertical-align: top;\n\tbackground-color: #fafafa;\n\tborder: 1px dashed #d9d9d9;\n\tborder-radius: 2px;\n\tcursor: pointer;\n\ttransition: border-color 0.3s;\n\tbackground-color: transparent;\n} */\n/*.ant-btn-default span {\n\tcolor: white;\n\tfont-size: 20px;\n}\n.ant-btn ant-btn-default {\n\tbackground-color: transparent;\n\tborder: 2px dashed white;\n\tcolor: white;\n\theight: auto !important;\n}*/\n/* button,\nhtml [type=\"button\"] {\n\tbackground-color: transparent;\n\tborder: 2px dashed white;\n\tcolor: white;\n\theight: auto !important;\n}\nbutton,\nhtml [type=\"button\"]:hover {\n\tbackground-color: #0595db;\n}\nbutton,\nhtml [type=\"button\"]:checked {\n\tbackground-color: transparent;\n}\nbutton,\nhtml [type=\"button\"]:active {\n\tbackground-color: transparent;\n}\nbutton,\nhtml [type=\"span\"] {\n\tbackground-color: transparent;\n} */\n.ant-upload-span:hover {\n\tbackground-color: #0595db !important;\n}\n\n.ant-upload-btn {\n\tbackground: none; /* Elimina el fondo del botón por defecto */\n}\n\n/* Estilos del botón cuando contiene contenido (después de cargar una foto) */\n.ant-upload-btn:not(:empty) {\n\tbackground: none; /* Asegúrate de que el fondo siga siendo transparente después de cargar una foto */\n}\n\n/* Estilos del botón cuando está en estado activo (haciendo clic) */\n.ant-upload-btn:active {\n\tbackground: none; /* Asegúrate de que el fondo siga siendo transparente durante el clic */\n}\n.ant-radio-disabled .ant-radio-inner:after {\n\tbackground-color: rgba(0, 0, 7);\n}\nspan.ant-radio + * {\n\tpadding-right: 8px;\n\tpadding-left: 8px;\n\tcolor: white;\n}\n.ant-input-number-handler-wrap {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\twidth: 22px;\n\theight: 100%;\n\tbackground: #fff;\n\tborder-radius: 0 2px 2px 0;\n\topacity: 0;\n\t/* transition: opacity .24s linear .1s; */\n\tbackground: #333a40;\n}\ncode,\nkbd,\npre,\nsamp {\n\tfont-size: 1em;\n\tfont-family: montserrat, sans-serif;\n}\n.react-datepicker__input-container > span {\n\tdisplay: none;\n}\nmapboxgl-ctrl-geocoder .suggestions {\n\tfont-size: 13px;\n\tbackground: rgb(95, 95, 95);\n}\n\n@media screen and (min-width: 640px) {\n\t.mapboxgl-ctrl-geocoder .suggestions {\n\t\tfont-size: 13px;\n\t\tbackground: rgb(95, 95, 95);\n\t}\n}\n\n/* Toasts da antd (message.success / message.error).\n   O `* { color: white }` no topo deste ficheiro pinta tambem o texto destes avisos,\n   que na antd tem fundo branco por omissao — davam branco sobre branco, ilegiveis.\n   Alinhados com o fundo do menu lateral (#0f2030, ver sidebar.js), que ja e escuro\n   e combina com o texto branco herdado. */\n.ant-message-notice-content {\n\tbackground: #0f2030;\n\tborder: 1px solid #1c3a52;\n\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);\n}\n\n.ant-message-custom-content span {\n\tcolor: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
